<template>
    <CardBase
        :config="content"
        :card-type="'hero'"
        :is-first="isFirst"
    />
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'

const props = defineProps<{
    content: HblSlot,
    isFirst?: boolean
}>()
</script>